const appConfig = {
  apiUrl: `${import.meta.env.VITE_API_URL}/v2`,
  debug: import.meta.env.VITE_DEBUG === 'true',
  environment: import.meta.env.MODE
} as const;

// type AppConfig = typeof appConfig;

export default appConfig;
